window.TechTrackUtils = class TechTrackUtils {
    static getDistance (lat1, lon1, lat2, lon2) {
        const R = 6378.137; // Radius of earth in KM
        const dLat = (lat2 - lat1) * Math.PI / 180;
        const dLon = (lon2 - lon1) * Math.PI / 180;
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const d = R * c;
        return d * 1000; // meters
    };

    static calculateCoordinate (currentValue, delta, limitValue) {
        currentValue += delta;
        if (delta > 0) {
            return currentValue > limitValue ? limitValue : currentValue;
        } else {
            return currentValue < limitValue ? limitValue : currentValue;
        }
    };
    
    static async sleep(delay) {
        await new Promise(resolve => setTimeout(resolve, delay  * 1000));
    }
};